import { useStorage, type RemovableRef } from "@vueuse/core";
import { defineStore } from "pinia";
import type { RouteLocationNormalized } from "vue-router";
import { getAppConfig } from "@/config/app-config";

type ClientStore = {
  client: RemovableRef<string>;
  theme: string;
  phoneNumber: string;
  whatsappNumber: string;
};

export enum ClientName {
  Galicia = "galicia",
  RioUruguaySeguros = "rus",
  Rapihogar = "rapihogar",
  Meridional = "meridional",
  Soelsac = "soelsac",
}

export const useClientStore = defineStore("clientStore", {
  state: (): ClientStore => ({
    client: useStorage("client", ""),
    theme: "",
    phoneNumber: "",
    whatsappNumber: "",
  }),

  getters: {
    formatPhoneNumber(state) {
      const phone = state.phoneNumber.replace(/ /g, "");
      return `tel:+54 ${phone}`;
    },
    formatWhatsappNumber(state) {
      const whatsapp = state.whatsappNumber.replace(/ /g, "");
      return `https://wa.me/54${whatsapp}`;
    },
    headerTheme(state) {
      if (state.client === ClientName.RioUruguaySeguros) {
        return `${state.theme} md:shadow-none`;
      }
      return `${state.theme} md:shadow-md`;
    },
  },
  actions: {
    setClientName() {
      const config = getAppConfig();
      this.client = config.clientName || ClientName.Rapihogar;
      this.theme = config.theme;
      this.phoneNumber = config.phoneNumber;
      this.whatsappNumber = config.whatsappNumber;
    },
    getOrganizationName(clientName: string) {
      const organizationNames: Record<string, string> = {
        rapihogar: "Vaitty",
        rus: "Río Uruguay Seguros",
        galicia: "Galicia Seguros",
        meridional: "Meridional Seguros",
        soelsac: "Soelsac",
      };

      return organizationNames[clientName] || "Vaitty";
    },
    getMetaTitleByOrg(
      routeName: RouteLocationNormalized["name"],
      clientName: string
    ) {
      const titlesByOrg: Record<string, Record<string, string>> = {
        rus: {
          Requests: "Mis asistencias",
          RequestsCreate: "Nueva asistencia",
          RequestView: "Detalle asistencia",
        },
        galicia: {
          Requests: "Mis asistencias",
          RequestsCreate: "Nueva asistencia",
          RequestView: "Detalle asistencia",
        },
        meridional: {
          Requests: "Mis solicitudes",
          RequestsCreate: "Nueva solicitud",
          RequestView: "Detalle de solicitud",
        },
        soelsac: {
          Requests: "Mis solicitudes",
          RequestsCreate: "Nueva solicitud",
          RequestView: "Detalle solicitud",
        },
        rapihogar: {
          Requests: "Mis solicitudes",
          RequestsCreate: "Nueva solicitud",
          RequestView: "Detalle solicitud",
        },
      };

      const orgTitles = titlesByOrg[clientName] || {};

      return orgTitles[String(routeName) || ""] || "";
    },
  },
});
